var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4307",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 1H42.8334V32H1.16675V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1522 16.6805C20.4362 15.8824 21.4037 14.8211 21.9234 13.612C22.2493 12.8539 21.694 12.0411 20.6832 11.7968C19.6724 11.5524 18.5887 11.9689 18.2629 12.727C17.7844 13.8404 17 14.8663 15.9608 15.7385L14.9957 16.5485C14.9465 16.5898 14.9039 16.6342 14.8667 16.6805",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9186 1.98869C9.92225 2.73593 9.57243 3.78431 9.86851 4.7432C11.147 4.96524 12.5448 4.70288 13.5412 3.95563C14.5375 3.20838 14.8873 2.16 14.5913 1.20112C13.3127 0.979062 11.9149 1.24144 10.9186 1.98869Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.638 6.67114C19.638 5.61433 18.897 4.68753 17.7836 4.16652C16.6702 4.68753 15.9292 5.61433 15.9292 6.67114C15.9292 7.72796 16.6702 8.65477 17.7836 9.17577C18.897 8.65477 19.638 7.72796 19.638 6.67114Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2417 6.82288C33.134 8.24212 33.134 10.5432 31.2417 11.9625",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9477 9.08377C39.9477 11.4887 37.3483 13.4383 34.1416 13.4383",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3994 16.6805C42.101 15.7181 42.5 14.614 42.5 13.4399C42.5 9.70359 38.4615 6.67477 33.4799 6.67477H23.6667V6.89701C23.6667 9.69964 26.6959 11.9717 30.4328 11.9717H30.5959C32.5439 11.9717 34.1231 13.156 34.1231 14.617C34.1231 15.4517 33.6069 16.1957 32.8018 16.6805",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 6.67421V5.9349C23.6667 4.65996 25.0448 3.62639 26.7448 3.62639H40.8227",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1626 28.875H14.8292V31.875H29.1626V28.875Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0157 22.9914C40.75 21.1422 41.9621 18.9978 42.4917 16.6786H1.4917C2.8062 22.4355 8.32661 27.115 15.5969 28.875H28.3866C30.2903 28.4141 32.0741 27.7531 33.6938 26.9248",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10351 3.29868C0.954429 4.91048 0.954429 7.5238 3.10351 9.13562C5.2526 10.7475 8.73702 10.7475 10.8861 9.13562L3.10351 3.29868Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99986 6.21828L5.6792 9.91484",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06665 7.21016L6.9954 6.21967",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1355 15.8443C9.22421 16.5278 7.95788 16.6861 7.30705 16.1979C6.65613 15.7097 6.86722 14.7599 7.77847 14.0766C8.68964 13.3931 9.95596 13.2348 10.6069 13.723C11.2577 14.2111 11.0467 15.1609 10.1355 15.8443Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1902 5.14688L21.6863 4.36096",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThai);
export default __webpack_public_path__ + "static/media/thai.6f556aaf1a885ede9d61847a0467bf82.svg";
export { ForwardRef as ReactComponent };